import React from "react";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

function DeleteButtonUserData(props) {
  return (
    <div
      className="square-button delete-button-color"
      title="Delete"
      // onClick={props.handleOpen}

      role="button"
      tabIndex={0}
      style={{
        backgroundColor: "#dc2626", // rouge
        color: "white",
        borderRadius: 8,
        width: 36,
        height: 36,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
      }}
      onClick={(e) => {
        if (props.onClick) return props.onClick(e);
        if (props.handleOpen) return props.handleOpen(e);
        if (props.handleOpen2) return props.handleOpen2(e);
      }}
    >
      <DeleteForeverIcon style={{ color: "white" }} />
    </div>
  );
}

export default DeleteButtonUserData;
